export default __webpack_public_path__ + "static/media/fi-br-backpack-active.191149ec.svg";